import { ElMessage } from 'element-plus'

/**
 * Centralized error notification utility using Element Plus
 */
export const errorNotifier = {
  /**
   * Show error notification
   */
  error(message: string, duration = 4000): void {
    ElMessage.error({
      message,
      duration,
      showClose: true,
    })
  },

  /**
   * Show warning notification
   */
  warning(message: string, duration = 4000): void {
    ElMessage.warning({
      message,
      duration,
      showClose: true,
    })
  },

  /**
   * Show info notification
   */
  info(message: string, duration = 3000): void {
    ElMessage.info({
      message,
      duration,
      showClose: true,
    })
  },

  /**
   * Show success notification
   */
  success(message: string, duration = 3000): void {
    ElMessage.success({
      message,
      duration,
      showClose: true,
    })
  },
}

